import React, { useState, useEffect } from "react";
import GeneralScheduleSlot from "./GeneralScheduleSlot";

export default function GeneralScheduleDayItem(props) {
  const [days, setDays] = useState([]);
  let lastSlot = 1;
  let generateEmptySlots = (fs, slotNo) => {
    let output = [];
    if (slotNo - fs > 1) {
      for (let i = fs; i < slotNo; i++) {
        output = output.concat(<td> </td>);
      }
      return output;
    }
  };
  return (
    <tr>
      <td class="dayCol">{props.data.dayName}</td>
      {props.data.slotItems.map(item => {
        const prevLastSlot = lastSlot;
        lastSlot = item.toNo;
        return (
          <React.Fragment>
            {generateEmptySlots(prevLastSlot, item.fromNo)}
            <GeneralScheduleSlot {...item} />
          </React.Fragment>
        );
      })}
    </tr>
  );
}



// WEBPACK FOOTER //
// ./src/pages/student_schedule/GenearalSchedule/GeneralScheduleDayItem.js